import { Component, inject, Input, signal } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { IEcoupon } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { libEcouponFormComponent } from '@web-nx-ng-tsc/ecoupon';
import { EcouponServiceService } from '../core/service/ecoupon-service.service';
import { tap } from 'rxjs';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'app-ecoupon-form-toyo',
  imports: [libEcouponFormComponent, RouterModule],
  templateUrl: './ecoupon-form-toyo.component.html',
  styleUrl: './ecoupon-form-toyo.component.scss',
})
export class EcouponFormToyoComponent {
  private readonly router = inject(Router);
  private readonly ecouponService = inject(EcouponServiceService);
  private readonly loggingService = inject(LoggingService);

  @Input() set id(item: string) {
    this.nameRoute.set(item);
    this.loggingService.log('this.errStatus', this.errStatus());

    this.ecouponService
      .getDetailCampaign(item)
      .pipe(
        tap((res: any) => {
          if (res.data) {
            this.detail = res.data;
            this.loggingService.log('getDetailCampaign', res);
            this.loggingService.log('getDetailCampaign', this.errStatus());
          }
        })
      )
      .subscribe();
    // this.ecouponService
    //   .getCheckCampaignExpire(item)
    //   .pipe(
    //     tap((res: any) => {
    //       if (res.data) {
    //         this.loggingService.log('this.errStatus', this.errStatus());
    //         // // status 10 = coupon can use
    //         // if (this.errStatus() !== 10) {
    //         //   this.routeToInfomation('');
    //         // }
    //       }
    //     })
    //   )
    // .subscribe();
    // this.ecouponService
    //   .getCheckCampaignFull(item)
    //   .pipe(
    //     tap((res: any) => {
    //       if (res.data) {
    //         this.loggingService.log('this.errStatus', this.errStatus());
    //         // if (this.errStatus() !== 10) {
    //         //   this.routeToInfomation('');
    //         // }
    //       }
    //     })
    //   )
    //   .subscribe();
  }
  // private readonly formEcouponService = inject(FormEcouponService);

  constructor() {
    // this.ecouponService.clearDataFormSignal();
    // this.ecouponService.clearErrorMessageSignal();
    // this.ecouponService.clearErroStatusSignal();
  }

  nameRoute = signal<string>('');
  path = 'toyo';
  // passFormSignal = this.formEcouponService.getpassFormSignal();
  errMsg = this.ecouponService.getErrorMessageSignal();
  errStatus = this.ecouponService.getErrorStatusSignal();
  detail: any;
  s = '';
  emitForm(value: IEcoupon) {
    //set for guard
    this.ecouponService.setDataFormSignal(value);
    this.loggingService.log('emitFormemitFormemitFormemitFormemitForm', value);
    this.loggingService.log('nameRoute', this.nameRoute());
    this.ecouponService
      .postForm(value)
      .pipe(
        tap((res: any) => {
          if (res.ok === 1) {
            // this.routeToOtp();
            this.ecouponService.clearErroStatusSignal();
            this.routeToInfomation('');
          } else if (res.error === 0) {
            this.ecouponService.setErrorStatusSignal(0);
            this.routeToInfomation('');
          } else if (res.error === 2) {
            this.ecouponService.setErrorStatusSignal(2);
            this.routeToInfomation('');
          } else if (res.error === 1) {
            this.ecouponService.setErrorStatusSignal(1);
            this.routeToInfomation('');
          } else {
            // this.ecouponService.setErrorStatusSignal(2);
            // this.ecouponService.setErrorMessageSignal(res.msg);
          }
        })
      )
      .subscribe();
  }

  routeToOtp() {
    this.router.navigateByUrl('e-coupon/otp');
  }
  routeToInfomation(path: string) {
    this.router.navigateByUrl('e-coupon/information');
  }
}
